
import Base from '../base';
import config from './config';

class CookieSettings extends Base {
	start() {
		this.timeoutId = null;

		this.presetRadio();

		this.on('change');
	}

	presetRadio() {
		const cookieValue = config.get(this.options);

		if (cookieValue === 'true') {
			this.query('input[value=true]').checked = true;
		} else if (cookieValue === 'false') {
			this.query('input[value=false]').checked = true;
		}
	}

	onChange(e) {
		e.preventDefault();

		const { target: { value } } = e;

		this.toggleCookie(value);
	}

	toggleCookie(acceptCookie) {
		this.hideFeedback();

		config.set(this.options, acceptCookie);

		this.showFeedback();
	}

	hideFeedback() {
		this.refs.feedback.classList.add('is-hidden');
	}

	showFeedback() {
		clearTimeout(this.timeoutId);

		this.refs.feedback.classList.remove('is-hidden');

		this.timeoutId = setTimeout(() => this.hideFeedback(), 1000);
	}
}

export default CookieSettings;
